


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_newInvoiceData_newInvoice } from '@/queries/__generated__/newInvoiceData';
import i18n from '@/i18n';
import { sortBy } from '@/utils/utils';
import { watchInvoice } from '@/app/invoiceWatch';
import gql from 'graphql-tag';

const INVOICE_SEND_BY_EHF = gql`
  mutation sendInvoiceByEhf($invoiceId: ID!) {
    sendInvoiceByEhf(
      input: {
        invoiceId: $invoiceId,
      }) {
      logInvoiceMail {
         id destination sentAt
        deliveryMethod
        sentBy { id name }
        deliveryStatus
        deliveryError
        attachmentsCount
      }
    }
  },
`;

@Component
export default class InvoiceSendByEHFButton extends Vue {
  private INVOICE_SEND_BY_EHF = INVOICE_SEND_BY_EHF;
  @Prop() private invoice!: GQL_newInvoiceData_newInvoice;
  @Prop({ type: String, default: 'standard' }) private color!: string;

  private performingRequest = false;

  get isLoading() {
    if (this.isDisabled) {
      return false;
    } else {
      return this.performingRequest ||
        this.stillSending
      ;
    }
  }

  get isDisabled() {
    return !this.invoice.customer.unit.canReceiveEhf3;
  }

  get stillSending() {
    if (this.invoice.emailLogs.length < 1) {
      return false;
    }
    const newestLog = sortBy(this.invoice.emailLogs, log => [ [ parseInt(log.id), 'desc' ] ])[0];

    switch (newestLog.deliveryStatus) {
      case 'before_sending':
        return true;
      default:
        return false;
    }
  }

  public sendMail() {
    this.performingRequest = true;
    // the rest of this delivery happens server side, so listen for it
    watchInvoice(this.invoice.id);
    this.$sMessage.info(i18n.t('Invoice.EHF.sending'));

    this.$apollo.mutate({
      mutation: INVOICE_SEND_BY_EHF,
      variables: {
        invoiceId: this.invoice.id,
      },
    }).then(data => {
      this.$set(this.invoice, 'emailLogs', this.invoice.emailLogs.concat(data.data.sendInvoiceByEhf.logInvoiceMail));
      this.$emit('sent');
    }).finally(() => {
      this.performingRequest = false;
    });
  }
}
